import React from "react";
import { Link } from "react-router-dom";
import classNames from 'classnames'

export default function ArticlesList(props) {
let reminder;
 if (props.item.id % 3 === 1 && props.item.id > 6 ) {
   reminder = 'col-12'
 } else if (props.item.id % 3 <= 2 && props.item.id > 3){
   reminder = 'col-12 col-md-6'
 } else {
   reminder = 'col-12 col-md-4'
 }
console.log(reminder) 
  return (
    <Link className={classNames("mt-3 full-card-div div-zoom", reminder)} to={props.item.link}>
      <div className='img-hover-zoom'>
      <img class="card-img article-image" src={props.item.img} alt="Artice" />

      </div>
      <div class="card-img-overlay text-overlay row justify-content-center">
        <h5 class="card-title bg-black col-0 align-self-end">
          <Link to={props.item.link}>{props.item.title} </Link>
        </h5>
      </div>
    </Link>
  );
}
